export default __webpack_public_path__ + "static/media/naac-college.453e157d.webp";